export default function global_variables()
{
    return {
        SINISTRE_CARE_WEBSERVICE: 'https://servo.integralewebservice.com/api',
    }
}